import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { DialogActions } from '@mui/material';

const dialogContentStyles = {
  backgroundColor: 'surface.light',
  pb: { md: 4, xs: 0 },
  px: { md: 'initial', xs: 0 },
};

const DistributionWizardLayout = ({ buttons, children, onClose, pageTitle, parentDetails }) => {
  return (
    <>
      <AppBar elevation={1} sx={{ backgroundColor: 'surface.white' }}>
        <Toolbar disableGutters sx={{ px: 1 }} variant="dense">
          <Typography noWrap sx={{ flexGrow: 1 }} variant="h6">
            {pageTitle}
          </Typography>
          <IconButton onClick={onClose} size="medium" sx={{ color: 'graphic.icons' }}>
            <CloseRoundedIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent sx={dialogContentStyles}>
        <Box
          mt={{ md: 6.5, xs: 4 }}
          sx={{
            display: 'flex',
            flexWrap: { lg: 'nowrap', xs: 'wrap' },
            justifyContent: 'center',
          }}
        >
          {parentDetails && <Box sx={{ width: { lg: '300px', xs: '100%' } }}>{parentDetails}</Box>}
          <Box sx={{ width: { lg: '760px', xs: '100%' } }}>{children}</Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ boxShadow: 7, p: 3 }}>{buttons}</DialogActions>
    </>
  );
};

DistributionWizardLayout.propTypes = {
  buttons: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  pageTitle: PropTypes.string.isRequired,
  parentDetails: PropTypes.node,
};

DistributionWizardLayout.defaultProps = {
  parentDetails: null,
};

export default DistributionWizardLayout;
